"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.versionOverrideSepoliaMock = exports.versionDataSepolia = void 0;
const tools_1 = require("@axiom-crypto/tools");
const endpoints_1 = require("../endpoints");
exports.versionDataSepolia = {
    v2: {
        Addresses: {
            Axiom: "0x69963768F8407dE501029680dE46945F838Fc98B",
            AxiomQuery: "0x83c8c0B395850bA55c830451Cfaca4F2A667a983",
        },
        Urls: {
            ApiBaseUrl: "https://api.axiom.xyz/v2",
        },
        Endpoints: {
            GetBlockHashWitness: endpoints_1.Path.Block + endpoints_1.Endpoints.GetBlockHashWitness,
            GetBlockMerkleProof: endpoints_1.Path.Block + endpoints_1.Endpoints.GetBlockMerkleProof,
            GetBlockParams: endpoints_1.Path.Block + endpoints_1.Endpoints.GetBlockParams,
            GetBlockRlpHeader: endpoints_1.Path.Block + endpoints_1.Endpoints.GetBlockRlpHeader,
            GetBlockMmrProof: endpoints_1.Path.Block + endpoints_1.Endpoints.GetBlockMmrProof,
            GetAllQueries: endpoints_1.Path.Query + endpoints_1.Endpoints.GetAllQueries,
            GetDataForQuery: endpoints_1.Path.Query + endpoints_1.Endpoints.GetDataForQuery,
            GetQueryCount: endpoints_1.Path.Query + endpoints_1.Endpoints.GetQueryCount,
            GetQueryData: endpoints_1.Path.Query + endpoints_1.Endpoints.GetQueryData,
            GetQuery: endpoints_1.Path.Query + endpoints_1.Endpoints.GetQuery,
        },
        Values: {
            MaxQuerySize: tools_1.AxiomV2CircuitConstant.UserMaxSubqueries,
            QueryEncodingVersion: 2,
        },
    },
};
exports.versionOverrideSepoliaMock = {
    v2: {
        Addresses: {
            Axiom: "0x69963768F8407dE501029680dE46945F838Fc98B",
            AxiomQuery: "0x83c8c0B395850bA55c830451Cfaca4F2A667a983",
        },
    },
};
//# sourceMappingURL=sepolia.js.map